
/*========================================================================
 * $Id: channels.js 130252 2018-02-12 11:59:26Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('service/channels',[
    "backbone",
    "i18n/i18n",
    "service/channel_factory",
    "api/v2/common",
    "underscore",
  ], function(
    Backbone,
    i18n,
    ChannelFactory,
    Common,
    _
) {

  /*
    TODO: differentiate between channels and 
          sources
   */
  var Channels = Backbone.Collection.extend({

    initialize: function(model, options) {
      Backbone.Collection.prototype.initialize.apply(this, arguments);
      
      this.channelFactory = new ChannelFactory(options);
      this.alerts = new Backbone.Collection();
      this.options = options;

      this.listenTo(this, "done", this.checkMessages);
      this.listenTo(this, "fail", this.failedCall);
      this.listenTo(i18n, "change:locale", this.changedLocale);
    },

    changedLocale: function (i18n) {
      this.trigger("change");
    },

    failedCall: function (channel, response) {
      var message = "<strong>" + i18n("Error") + "</strong> " + response.error + " (" + response.url  + ")";
      this.addAlert({
          id: message,
          level: "error",
          message: message
      });
    },

    checkMessages: function (channel, response) {
      if (!response) return;
      this.addAlerts(response.status_messages);
    },

    addAlerts: function (status_messages) {
      status_messages = Common.StatusMessages.parse(status_messages);
      var that = this;

      _.each(status_messages, function (model, id) {
        if (id === "timeout" || id == "no_results") return;

        model = _.clone(model);
        model.id = id;
        model.level = model.error ? "error" : model.warning ? "warning" : "info";
        model.service_ids = model.service_ids && model.service_ids.join(", ");
        that.addAlert(model);
      });
    },

    addAlert: function (model) {
      if (model && model.hidden) return;
      this.alerts.add(model);
    },

    _prepareModel: function(attrs, options) {
      var ch = this.channelFactory.createChannel(attrs,options);
      ch.prepareRequest = _.bind(this.prepareRequest, this, ch);
      return ch;
    },

    prepareRequest: function(channel, request) { 
      try {
        if (!request.user_context) {
          request.user_context = {};
        }
        if (_.isObject(request.user_context)) {
          if (this.options && this.options.referer) 
            request.user_context.referer = request.user_context.referer || this.options.referer
          if (this.options && this.options.sessionDescription)
            request.user_context.session_description = request.user_context.session_description || this.options.sessionDescription;
          request.user_context.locale = i18n.locale;
          request.user_context.service_id = (channel.get) ? channel.get("id") : channel.id;
          request.user_context.utc_time_zone_differential_in_seconds = (-new Date().getTimezoneOffset() * 60);
        }
      } catch (e) {
        if (console && console.warn)  
          console.warn("Failed to prepare request", e);
      }
      return this;
    }
    
  });

  Channels.ignoreSuccessiveErrorsCallback = function(channel, error) {

    if (!this.callback || !this.channels) 
      return;

    var ctx = this;    
    if (!ctx.failedChannels) {
      ctx.failedChannels = {};
    }
    
    var errorStatus = -1;
    if (error && error.status) 
      errorStatus = error.status;
    
    if (channel && channel.id) {
      // ignore successively failed channels.
      if (!ctx.failedChannels[channel.id]) {
        ctx.failedChannels[channel.id] = [];
      }
      
      if (_.contains(ctx.failedChannels[channel.id], errorStatus)) {
        return;
      }
      else 
      {
        ctx.failedChannels[channel.id] = _.union(ctx.failedChannels[channel.id], [errorStatus]);
      }
    }
    
    if (ctx.failedChannels[channel.id] && ctx.failedChannels[channel.id].length == 1) {
      // reset once ..
      this.channels.once("done", function(channel) {
        if (!channel || !channel.id) {
          ctx.failedChannels = {};
        }
        else {
          if (ctx.failedChannels) {
            delete ctx.failedChannels[channel.id];
          }
        }
      });
    }
      // call the callback ..
    return this.callback.apply(this.context, arguments);
  }

  return Channels;

});
